import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
// import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Button, makeStyles, Typography, Container } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
//import VoucherPaymentMobile from '../components/PaymentServiceSwitch/VoucherPaymentMobile';
import VoucherPaymentWeb from '../components/PaymentServiceSwitch/VoucherPaymentWeb';
import { urlVoucher } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
//import md5 from 'md5';
import { sendMobile } from '../functions/mobile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import Footer from '../components/Complements/Footer';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
//import VoucherPaymentWeb from '../components/PaymentServiceSwitch/VoucherPaymentWeb'

const useStyles = makeStyles((theme) => ({
    buttonViewMovements: {
        color: '#2E2757',
        [theme.breakpoints.up('xs')]: {
            fontSize: '70%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
    },
    divStandard: {
        //margin: "20px",
        padding: "20px",
        // border: '2px solid #BEBCC0',
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    }

}));

const VoucherServicePayContainer = props => {
    const { classes, balances, parameters } = props

    const classes2 = useStyles()

    const [codespaginate, setCodesPaginate] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [dateStart, setDateStart] = useState(new Date(moment().startOf('month')))
    //const [dateEnd, setDateEnd] = useState(new Date())
    const dateEnd = new Date()
    const [dateEndRange, setDateEndRange] = useState(dateEnd)
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [accountSelected, setAccountSelected] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')

            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEndRange, 1, accountSelected.codigo)
        }
        return unmount()
    }

    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {
    //console.log('los valores del accountSelected son',accountSelected)
        setLoading(true)

        findTransferCore({
            $limit: 10,
            $skip: rows,
            type: {
                $in: [27, 29]
            },
            state: true,
            originAccountNumber: secuencial,
            createdAt: {
                $lte: valuedateEnd,
                $gte: valuedateStart
            },
            $sort: {
                createdAt: -1
            }
        }).payload.then(
            response => {

                // console.log(response)

                const { data, total } = response

                convertJsonToData(data, total, numberpage)

                setLoading(false)
            }
        ).catch(
            error => {
                //console.log(error)
                setLoading(false)
            }
        )
    }

    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];

        data.forEach(row => {

            try {

                let transfertjson = JSON.parse(row.dataVoucher);
                //console.log(transfertjson)
                (transfertjson.uuidTransaccion) && resul.push({
                    ...transfertjson,
                    fechaTransaccion: row.createdAt
                });

            } catch (error) {
                //console.log(error)
            }

        })

        //console.log("TODOS LOS MOVIMIENTOS: ", resul)

        setCodesPaginate(resul)

        getDataViewTable(total, numberpage);

    }

    useEffect(mount, [])

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEndRange(date)
    }



    const handleSubmit = (val) => {
        // console.log(val)
    }
    // mayor

    const getDataViewTable = (total, numberpage) => {

        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if (residuo > 0) {
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        //setAllCodes([])
        //console.log(allcodes)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.codigo)

    }


    const onChangePaginationCodes = (e, numberpage) => {

        handleGetDataMovementsBySecuencialAccount((numberpage - 1) * 10, dateStart, dateEnd, numberpage, accountSelected.codigo);
        //setTransactionPaginate(datacodespaginate)
        //setPage(numberpage)
    }

    //handle
const handleSelectCode = (val) => {
    setDateValue(val);
    setLoading(true);

    if (val === 'Todos los movimientos') {
        const defaultStart = new Date(moment().startOf('month'));
        const defaultEnd = new Date();

        setDateStart(defaultStart);
        setDateEndRange(defaultEnd);

        handleGetDataMovementsBySecuencialAccount(
            0,
            defaultStart,
            defaultEnd,
            1,
            accountSelected.codigo
        );

        setLoading(false);
    } else {
        let obj = JSON.parse(val);

        // Asegurar que sean números
        const selectedMonth = parseInt(obj.month, 10);
        const selectedYear = parseInt(obj.year, 10);
        const currentMonth = moment().month();
        const currentYear = moment().year();

        let selectMonth = new Date(selectedYear, selectedMonth, 1);
        const newStart = new Date(moment(selectMonth).startOf('month'));

        let newEnd;

        // Si el mes/año seleccionados son el actual, usar hoy como fin
        if (selectedMonth === currentMonth && selectedYear === currentYear) {
            newEnd = new Date();
        } else {
            // Si no, usar fin del mes seleccionado
            newEnd = new Date(moment(selectMonth).endOf('month'));
        }

        setDateStart(newStart);
        setDateEndRange(newEnd);

        handleGetDataMovementsBySecuencialAccount(
            0,
            newStart,
            newEnd,
            1,
            accountSelected.codigo
        );

        setLoading(false);
    }
};


    const handleFindRange = () => {

        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEndRange, 1, accountSelected.codigo)

    }

    const handleViewVoucher = (row) => {
        // console.log("MOVIMIENTO SELECCIONADO: ", row)

        if (row.identificacionDeudor) {

            setDialog({
                open: true, title: 'Comprobante',
                children: <Container component="main" maxWidth="xl">
                    <VoucherPaymentWeb
                        monto={parseFloat(row.valor).toFixed(2)}
                        titleheader={"TRANSACCIÓN EXITOSA"}
                        title={"PAGO DE SERVICIOS"}
                        titleone={"DATOS SERVICIO"}
                        viewVoucher={true}
                        handleResetPayment={handleCLoseDialog}
                        databodyone={[
                            {
                                title: "Servicio",
                                value: row.servicio,
                                order: 1
                            },
                            {
                                title: "Institución",
                                value: row.nombreInstitucion,
                                order: 2
                            },
                            {
                                title: "Referencia",
                                value: row.referencia,
                                order: 3
                            },
                            {
                                title: "Identificación",
                                value: row.identificacionDeudor,
                                order: 4
                            },
                            {
                                title: "Deudor",
                                value: row.nombreDeudor,
                                order: 5
                            },
                            {
                                title: "Rubro",
                                value: row.rubros,
                                order: 6
                            },
                            {
                                title: "Monto",
                                value: "$ " + parseFloat(row.monto).toFixed(2),
                                order: 8
                            },
                            {
                                title: "Factura",
                                value: row.factura,
                                order: 9
                            },
                            {
                                title: "Comisión",
                                value: "$ " + parseFloat(row.comision).toFixed(2),
                                order: 10
                            }
                        ]}
                        titletwo={"DATOS EMISOR"}
                        databodytwo={[
                            {
                                title: "# Socio",
                                value: row.numeroCliente,
                                order: 1
                            },
                            {
                                title: "Socio",
                                value: row.nombreCliente,
                                order: 2
                            },
                            {
                                title: "Número de cuenta",
                                value: handleMaskNumberAccount(row.numeroCuentaOrigen),
                                order: 3
                            },
                            {
                                title: "Fecha",
                                value: moment(row.fecha).format("YYYY-MM-DD"),
                                order: 4
                            },
                            {
                                title: "Concepto",
                                value: row.concepto,
                                order: 5
                            },
                            {
                                title: "Dcto. de transacción",
                                value: row.documentoTransaccion,
                                order: 6
                            },
                            {
                                title: "Dispositivo",
                                value: row.dispositivo,
                                order: 7
                            }
                        ]}
                        //monto={row.monto}
                        handleDownloadVoucher={() => {
                            try {
                                let namefile = row.nombreArchivoComprobante
                                if (localStorage.caja_app !== undefined) {
                                    let send = {
                                        type: 'action',
                                        action: 'download_voucher',
                                        data: urlVoucher + namefile + ".pdf",
                                        messageSend: 'Pago de servicios'
                                    }
                                    sendMobile(JSON.stringify(send))
                                } else {
                                    window.open(urlVoucher + namefile + ".pdf", '_blank');
                                }
                            } catch (error) {
                                //console.log(error)
                            }
                        }}
                        handleDownloadDevice={() => {
                            try {
                                let namefile = row.nombreArchivoComprobante
                                let send = {
                                    type: 'action',
                                    action: 'export_voucher',
                                    data: urlVoucher + namefile + ".pdf",
                                    nameFile: namefile,
                                    extension: 'pdf',
                                    messageSend: 'Pago de servicios'
                                }
                                sendMobile(JSON.stringify(send))
                            } catch (error) {
                                //console.log(error)
                            }
                        }}
                        //handleSendEmailWithVoucher = { () => { handleResendEmailWithVoucher(row) }}
                        typesizegrid={6}
                    /></Container>
            })
        } else {

            setDialog({
                open: true, title: 'Comprobante',
                children: <Container component="main" maxWidth="xl"> <VoucherPaymentWeb
                    monto={parseFloat(row.valor).toFixed(2)}
                    titleheader={"TRANSACCIÓN EXITOSA"}
                    title={"PAGO DE SERVICIOS"}
                    titleone={"DATOS SERVICIO"}
                    viewVoucher={true}
                    handleResetPayment={handleCLoseDialog}
                    databodyone={[
                        {
                            title: "Servicio",
                            value: row.servicio,
                            order: 1
                        },
                        {
                            title: "Institución",
                            value: row.nombreInstitucion,
                            order: 2
                        },
                        {
                            title: "Número de celular",
                            value: row.referencia,
                            order: 3
                        },
                        {
                            title: "Monto",
                            value: "$ " + parseFloat(row.monto).toFixed(2),
                            order: 4
                        },
                        {
                            title: "Comisión",
                            value: "$ " + parseFloat(row.comision).toFixed(2),
                            order: 5
                        },
                        {
                            title: "Factura",
                            value: row.factura,
                            order: 6
                        }
                    ]}
                    titletwo={"DATOS EMISOR"}
                    databodytwo={[
                        {
                            title: "# socio",
                            value: row.numeroCliente,
                            order: 1
                        },
                        {
                            title: "Socio",
                            value: row.nombreCliente,
                            order: 2
                        },
                        {
                            title: "Número de cuenta",
                            value: handleMaskNumberAccount(row.numeroCuentaOrigen),
                            order: 3
                        },
                        {
                            title: "Fecha",
                            value: moment(row.fecha).format("YYYY-MM-DD"),
                            order: 4
                        },
                        {
                            title: "Concepto",
                            value: row.concepto,
                            order: 5
                        },
                        {
                            title: "Dcto. de transacción",
                            value: row.documentoTransaccion,
                            order: 6
                        },
                        {
                            title: "Dispositivo",
                            value: row.dispositivo,
                            order: 7
                        }
                    ]}
                    handleDownloadVoucher={() => {
                        try {
                            let namefile = row.nombreArchivoComprobante
                            if (localStorage.caja_app !== undefined) {
                                let send = {
                                    type: 'action',
                                    action: 'download_voucher',
                                    data: urlVoucher + namefile + ".pdf",
                                    messageSend: 'Comprobante Credito'
                                }
                                sendMobile(JSON.stringify(send))
                            } else {
                                window.open(urlVoucher + namefile + ".pdf", '_blank');
                            }
                        } catch (error) {
                            //console.log(error)
                        }
                    }}
                    handleDownloadDevice={() => {
                        try {
                            let namefile = row.nombreArchivoComprobante
                            let send = {
                                type: 'action',
                                action: 'export_voucher',
                                data: urlVoucher + namefile + ".pdf",
                                nameFile: namefile,
                                extension: 'pdf',
                                messageSend: 'Pago de servicios'
                            }
                            sendMobile(JSON.stringify(send))
                        } catch (error) {
                            //console.log(error)
                        }
                    }}
                    //handleSendEmailWithVoucher = { () => { handleResendEmailWithVoucher(row) }}
                    typesizegrid={6}
                /></Container>
            })
        }

    }
    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table>
                            <Thead>
                                <Tr>
                                    <Th>Fecha</Th>
                                    <Th>Socio</Th>
                                    <Th>Institución</Th>
                                    <Th className={"colunmvalue"}>Monto</Th>
                                    <Th>Rubro</Th>
                                    <Th>Comprobante</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {

                                    codespaginate.map(row => (
                                        <Tr key={`${row.documentoTransaccion}`}>
                                            <Td>{moment(row.fechaTransaccion).format("YYYY-MM-DD HH:mm:ss")}</Td>
                                            <Td>{row.nombreCliente}</Td>
                                            <Td>{row.nombreInstitucion}</Td>
                                            <Td>$ {row.valor}</Td>
                                            <Td>{(row.rubros) ? row.rubros : "RECARGAS"}</Td>
                                            <Td>
                                                <Button variant='contained' aria-label="delete" onClick={() => handleViewVoucher(row)}>
                                                    <Typography className={classes2.buttonViewMovements} align="left">
                                                        VER
                                                    </Typography>
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                        <Pagination
                            count={count}
                            style={{ marginTop: '5px' }}
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado pago de servicios en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return <div className={classes2.divStandard}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8} sm={12}>
                    <Typography>Detalle de pago de servicios de la Cuenta </Typography>
                </Grid>
                <Grid item xs={12} md={4} lg={4} sm={12}>

                </Grid>
            </Grid>
            <SelectForm
                name={'Periodo'}
                label={'Seleccione periodo '}
                parameters={parameters}
                classes={classes}
                dateValue={dateValue}
                onSelected={(val) => handleSelectCode(val)}
                onSubmit={handleSubmit}
            ></SelectForm>
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                    maxDate={dateEndRange}
                                    maxDateMessage="La fecha de inicio no debe ser superior a la fecha de fin"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
<KeyboardDatePicker
    autoOk
    variant="inline"
    format="dd/MM/yyyy"
    margin="normal"
    id="date-end"
    label="Fecha de fin"
    value={dateEndRange}
    onChange={handleDateEnd}
    KeyboardButtonProps={{
        'aria-label': 'change date',
    }}
    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
    maxDate={new Date()}
    maxDateMessage="La fecha de Inicio no debe ser superior a la fecha actual"
    minDate={dateStart}
    minDateMessage="La fecha de fin no debe ser anterior a la fecha inicio"
/>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: '#b98919' }} aria-label="add" onClick={handleFindRange} >
                                <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                            </Fab>
                            {/* <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                // color: "#000000",
                                fontSize: "120%"
                            }}>
                                CONSULTAR
                            </Typography> */}
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: 'red' }} aria-label="add" onClick={() => history.push('/')} >
                                <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                            </Fab>
                            {/* <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                // color: "#000000",
                                fontSize: "120%"
                            }}>
                                CANCELAR
                            </Typography> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br /> <br />
            <Grid container spacing={3} justify="center" alignItems="center">
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }

    const handleMaskNumberAccount = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }
    }

    const renderHeader = () => {
        return <div className={classes2.divStandard}>
            <Typography>Pago de Servicios</Typography>
            <FormControl variant="outlined" style={{ maxWidth: '100%', marginTop: 16 }}>
                <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                <Select
                    label="Seleccione una Cuenta"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={balances[0]}
                    onChange={(e) => handleAccountFind(e.target.value)}
                >
                    {
                        balances.map(option => {
                            return <MenuItem key={option.codigo} value={option}>{`${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}</MenuItem>
                        })
                    }
                </Select>
            </FormControl>
        </div>
    }
    return (
        <div>
            <Grid xs={12} style={{padding:"20px 40px 0"}}  >
                <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Comprobantes</Typography>
            </Grid>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={true}
                panel={2}
            />
            <Footer />
            <LoadingScreen open={loading} />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
        </div>
    );
};

VoucherServicePayContainer.propTypes = {
    balances: PropTypes.array.isRequired,
};

export default connect(null, { getCodes, sendEmailWithVoucher, findTransferCore })(VoucherServicePayContainer);

//export default VoucherServicePayContainer;
